export const versionInfo = {
  gitTag: 'v-1.3.0-2-ge180ba5a',
  tag: 'v-1.3.0',
  commitsAhead: '2',
  buildDate: 'Fri, 18 Sep 2026 07:39:11 GMT'
};
